module.exports = __webpack_public_path__ + "img/map-marker-alt-solid.c17988d6.svg";